import React, { useState, useEffect } from "react";
import { Modal, Card, Form, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getTermsConditions, editTermsConditions } from "../../common/api";
import { ShowToast } from "../../common/function";
import { format } from "date-fns";
import { Sentry, Spinner } from "react-activity";

export default function Pages() {
  const [show2, setShow2] = useState(false);
  const [termsList, setTermsList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedPage, setSelectedPage] = useState({});
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleClose2 = () => {
    setShow2(false);
    setSelectedPage({});
    setDescription("");
    setErrors({});
  };

  const handleShow2 = (row) => {
    setSelectedPage(row);
    setDescription(row.description);
    setShow2(true);
  };

  const getTerms = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const res = await getTermsConditions(token);
    if (res.success) {
      setLoading(false);
      const formatted = res.body.map((item) => ({
        id: item._id,
        name: item.title,
        description: item.description,
        date: item?.createdAt?formatDate(item?.createdAt):"N/A",
      }));
      setTermsList(formatted);
    }
  };

  const formatDate = (dateString) => {
    return dateString?format(new Date(dateString), "dd-MM-yyyy"):"N/A";
  };

  useEffect(() => {
    getTerms();
  }, []);

  const handleUpdate = async () => {
    if (!description.trim()) {
      setErrors({ description: "Please enter description" });
      return;
    }
    setIsLoading(true)
    const token = localStorage.getItem("token");
    const res = await editTermsConditions(token, {
      termsConditionId: selectedPage.id,
      title: selectedPage.name,
      description,
    });
    setIsLoading(false)
    if (res.success) {

      ShowToast(1, "Page updated successfully");
      getTerms();
      handleClose2();
    } else {
      ShowToast(0, res.message || "Failed to update");
    }
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link className="btnedit" onClick={() => handleShow2(row)}>
            <Icon icon="tabler:pencil" />
          </Link>
        </>
      ),
    },
  ];

  const filteredData = termsList.filter((item) =>
    JSON.stringify(item).toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="py-4">
          <h5>All Pages</h5>
        </Card.Header>
        <Card.Body>
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="searchfield"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          {loading ? ( <Sentry
                  color="#2B5AAC"
                  size={30}
                  speed={1}
                  animating={true}
                  style={{ marginLeft: "45%" }}
                />
          ) : (
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            responsive
            className="custom-table"
          />
          )}
        </Card.Body>
      </Card>

      {/* Edit Modal */}
      <Modal size="lg" show={show2} onHide={handleClose2} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="modalhead">Edit Page</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3 form-group">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                value={selectedPage.name || ""}
                readOnly
              />
            </Form.Group>
            <Form.Group className="mb-3 form-group">
              <Form.Label>Description</Form.Label>
              <CKEditor
                editor={ClassicEditor}
                data={description}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setDescription(data);
                  setErrors({});
                }}
              />
              {errors.description && (
                <p className="text-danger mt-2">{errors.description}</p>
              )}
            </Form.Group>
          </Form>
          <Button className="btn btn-primary px-4 w-100" onClick={handleUpdate} disabled={isLoading}>
            {isLoading ? (
              <Spinner animation="border" variant="primary" size={15} />
            ) : (
              "Update"
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
